import React, {useRef} from 'react';
import i18n from 'i18next';
import Modal from "@/Components/Modals/Modal";
import ModalFooter from "@/Components/Modals/ModalFooter";
import {Dialog} from "@headlessui/react";
import {usePage} from "@inertiajs/inertia-react";

export default function UpdatePaymentDetailsModal( {paymentDue, paymentFailed, isOpen }) {

    const isOrgOwnerOrAdmin = usePage().props.auth.current_organization.is_owner_or_admin;
    const invoiceUrl = usePage().props.invoice_url;
    const isImpersonating = usePage().props.auth.user.isImpersonating;
    let customStyle = {};
    if (isImpersonating){
        // In case we are displaying the impersonation bar, we need to move the background
        // div down a bit so that the user can click/interact with it
        customStyle = {top: '40px'};
    }

    let initialFocusRef = useRef(null);

    if (isOrgOwnerOrAdmin) {
        return (
            <Modal
                title={i18n.t("update-payment-details-modal.update-payment-details")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                disableCloseButton={true}
                style={customStyle}
            >
                <div className="modal-body">
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        { paymentFailed &&
                            <span> {i18n.t("update-payment-details-modal.no-billing-information-error")} </span> }
                        { paymentDue &&
                            <span> {i18n.t("update-payment-details-modal.payment-overdue-error")} </span> }
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        onClick={() => window.location.href = invoiceUrl}
                        className="btn btn-primary"
                        style={{marginRight: '6px'}}
                    >{i18n.t("update-payment-details-modal.continue-button")}
                    </button>
                </ModalFooter>
            </Modal>
        );
    } else {
        return (
            <Modal
                title={i18n.t("update-payment-details-modal.missing-payment-details")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                disableCloseButton={true}
                style={customStyle}
            >
                <div className="modal-body">
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("update-payment-details-modal.payment-warning")}
                    </Dialog.Description>
                </div>
            </Modal>
        );
    }
}
